// Header.js
import React, { useContext, useState } from 'react';
import headerStyle from '../Components/Header.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Usercontext } from '../App';
import { signOut } from '../utilities/signOut';

const Header = ({ className }) => {
  const {userdata, setuserdata} = useContext(Usercontext)
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleScrollToServices = () => {
    const element = document.getElementById('products-section');
    if (element) {
        const headerHeight = document.querySelector(`.${headerStyle.header}`).offsetHeight;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};


  return (
    <header className={`${headerStyle.header} ${className}`}>
      <div className={headerStyle.logo}>
        <img className={`${headerStyle.logoimg}`} src='/Images/Logo.png'/>
      </div>
      <nav className={`${headerStyle.nav} ${isMenuOpen ? headerStyle.open : ''}`}>
        <ul>
          
          {userdata?.isAdmin 
          ?
            <li><Link to="/">Admin</Link></li>
          :             
            <li><Link to="/">Home</Link></li> 
          }
          <li><Link to="/about">About</Link></li>
          {/* <li><Link to="#products" onClick={handleScrollToServices}>Products</Link></li> */}
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link onClick={()=>{
            if(userdata!=null)
            {
              signOut()
            }
            setuserdata(null)
            navigate('/signuplogin', {replace: true}) 
          }}>{userdata!==null?'logout':'Login/Signup'}</Link></li>
          <li>
          {userdata?.isAdmin ? 
            <li><Link to="/vieworders">View Orders</Link></li>
          :            
            <li><Link to="/myorders">My Orders</Link></li>
          }  

            <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
            <button
              style={{ background: 'none', paddingLeft: '10px', paddingRight: '2px', color: 'white', margin: 0, border: "0px" }}
              type="button"
              onClick={() => {
                document.body.classList.toggle('dark-mode');
                setDarkMode((prev) => !prev);
              }}
            >
              {darkMode ? 'Light' : 'Dark'}
            </button>
          </li>
          <div className={headerStyle.phone} style={{ margin: 'auto', paddingLeft: '10px', paddingRight: '10px' }}>
            <li>
              <FontAwesomeIcon icon={faPhone} />
              <a id={headerStyle.number} href="#phone"> 9904157082</a>
            </li>
          </div>
          <li style={{ marginLeft: '10px' }}>
            <a href="https://www.indiamart.com/shital-paints/" target="_blank" rel="noopener noreferrer">
              <img
                src={('/Images/indiamart.png')}
                alt="IndiaMart"
                className={headerStyle.indiamartImage}
              />
            </a>
          </li>
        </ul>
      </nav>
      <button className={headerStyle.hamburger} onClick={toggleMenu}>
        ☰
      </button>
    </header>
  );
};

export default Header;
